
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/[alias]",
      function () {
        return require("private-next-pages/products/[alias].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/[alias]"])
      });
    }
  